export default "__VITE_ASSET__ec27cfc0__"